<template>
  <v-content>
    <v-container>
      <v-layout text-xs-center wrap>
        <v-flex xs12>
          <h3>Redirecting...</h3>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: "Redirect",
  created() {
    this.$router.push("/");
  }
};
</script>

<style scoped>
</style>

